import { Component, OnInit } from '@angular/core';
import { VersionCheckService } from '../../shared/_services/version-check.service';
import { TermsOfService } from '@/app/features/signup/register.model';
import { first } from 'rxjs/operators';
import { ApiService } from '../../shared/_services/api.service';

@Component({
  selector: 'app-footer',
  templateUrl: './app-footer.component.html',
  styleUrls: ['./app-footer.component.less']
})
export class AppFooterComponent implements OnInit {

  year = new Date().getFullYear();
  isShowTermsModal = false;
  termsModalType: string;
  termsModalTitle = {
    tos: 'Terms of Service',
    dpa: 'Data Processing Addendum'
  };
  termsModalContent = {
    tos: '',
    dpa: ''
  };

  constructor(
    private vcs: VersionCheckService,
    private api: ApiService
  ) {}

  ngOnInit() {
    this.getLatestTerms();
  }

  checkVersion() {
    this.vcs.checkVersion();
  }

  onChangeIsUpdateAvailable(value: boolean) {
    this.vcs.setIsRefreshNeeded(value);
  }

  toggleTermsModal(type: string) {
    this.termsModalType = type;
    this.isShowTermsModal = !this.isShowTermsModal;
  }

  private getLatestTerms() {
    this.api.getLatestTermsOfService().pipe(first()).subscribe(
      (res: TermsOfService) => {
        this.termsModalContent.tos = res.content;
      }
    );
    this.api.getLatestDataProcessingAddendum().pipe(first()).subscribe(
      (res: TermsOfService) => {
        if (res?.content) {
          this.termsModalContent.dpa = res.content;
        }
      }
    );
  }
}
